<div class="container  col-md-12">

  <div theme class="dsb-container"  [styleObj]='brandStyleTheme'>

    <h3 mat-dialog-title>{{title}}</h3>
    <mat-dialog-content>

      <h5>{{message}}</h5>

    </mat-dialog-content>
    <mat-dialog-actions align="center">
      @if (isConfirmButtonVisible) {
        <button class="btn btn-submit" (click)="onConfirmClick()" tabindex="1">{{confirmButtonText}}</button>
      }
      @if (isCancelButtonVisible) {
        <button class="btn btn-cancel"(click)="onCancelClick()" tabindex="-1">{{cancelButtonText}}</button>
      }
    </mat-dialog-actions>

  </div>

</div>
